/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

const NODE_ENV = process.env.NODE_ENV;
const IS_MOBILE = window.matchMedia('(any-pointer:coarse)').matches;

// Main environment variables
const ENV = Object.freeze({
    // Node environment
    NAME: NODE_ENV,
    IS_PROD: NODE_ENV === 'production',
    IS_DEV: NODE_ENV === 'development',

    // Device
    IS_MOBILE,
    IS_DESKTOP: !IS_MOBILE,

    // Supports
    SUPPORTS_VH:
        'CSS' in window &&
        'supports' in window.CSS &&
        window.CSS.supports('height: 100svh') &&
        window.CSS.supports('height: 100dvh') &&
        window.CSS.supports('height: 100lvh')
});

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
    LOADING: 'is-loading',
    FIRST_LOADED: 'is-first-loaded',
    LOADED: 'is-loaded',
    READY: 'is-ready',
    FONTS_LOADED: 'fonts-loaded',
    LAZY_CONTAINER: 'c-lazy',
    LAZY_LOADED: '-lazy-loaded'
    // ...
});

// Custom js events
const CUSTOM_EVENT = Object.freeze({
    RESIZE_END: 'loco.resizeEnd',
    VISIT_END: 'loco.visitEnd'
    // ...
});

// Fonts parameters
const FONT = Object.freeze({
    EAGER: [
        { family: 'ABCDiatype', style: 'normal', weight: 400 },
        { family: 'ABCDiatype', style: 'italic', weight: 400 },
        { family: 'ABCDiatype', style: 'normal', weight: 700 },
        { family: 'ABCDiatype', style: 'italic', weight: 700 },
        { family: 'SuisseIntlCond', style: 'normal', weight: 400 }
    ]
});

// CSS Breakpoints
const BREAKPOINTS = Object.freeze({
    FROM_2XS:   340,
    TO_2XS:     339,
    FROM_XS:    500,
    TO_XS:      499,
    FROM_SM:    700,
    TO_SM:      699,
    FROM_MD:    1000,
    TO_MD:      999,
    FROM_LG:    1200,
    TO_LG:      1199,
    FROM_XL:    1400,
    TO_XL:      1399,
    FROM_2XL:   1600,
    TO_2XL:     1599,
    FROM_3XL:   1800,
    TO_3XL:     1799,
    FROM_4XL:   2000,
    TO_4XL:     1999,
    FROM_5XL:   2400,
    TO_5XL:     1399
})

export { ENV, CSS_CLASS, CUSTOM_EVENT, FONT, BREAKPOINTS };
